import * as Language from "../constants/Language";
import * as FavoriteAmounts from "../constants/FavoriteAmount";
var defaultConfig = {
    countryCode: "KG",
    languageId: Language.resolveLanguageId(),
    darkTheme: localStorage.getItem("darkTheme") !== null ? localStorage.getItem("darkTheme") === 'true' : true,
    favoriteAmounts: {
        favorite_1: localStorage.getItem("favorite_1") || FavoriteAmounts.FAVOURITE_1,
        favorite_2: localStorage.getItem("favorite_2") || FavoriteAmounts.FAVOURITE_2,
        favorite_3: localStorage.getItem("favorite_3") || FavoriteAmounts.FAVOURITE_3,
        favorite_4: localStorage.getItem("favorite_4") || FavoriteAmounts.FAVOURITE_4
    }
};
export var CONFIG = defaultConfig;



// WEBPACK FOOTER //
// ./src/config/index.js